<template>
  <base-page-component>
    <b-card>
      <div slot="header">
        <button class="btn btn-success mt-1" @click="showCreate"><i title="Create a new account" class="fa fa-plus-square"></i> <strong class="text-white">Create New</strong></button>
      </div>

      <!-- User Interface controls -->
      <b-row>
        <b-col md="12">
          <div class="" style="text-align:right;">Showing {{ getRowCount() }} / {{ totalCount }} records</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="8" class="my-1">
          <b-form-group class="mb-1">
            <b-input-group v-on:keyup.enter="submitSearch">
              <b-form-input class="mr-2 mt-1" v-model="tbxFilter" id="tbxFilter" placeholder="Type to Search" style="min-width: 200px;"  />
              <b-input-group-append class="mt-1">
                <b-form-select class="mr-2" v-model="ddAccountStatus" id="ddAccountStatus">
                  <option value="0">All (Status)</option>
                  <option value="1">Active Only</option>
                  <option value="2">Disabled Only</option>
                </b-form-select>
                <b-form-select class="mr-2" v-model="ddAccountType" id="ddAccountType">
                  <option value="0">All (Acct Type)</option>
                  <option value="1">mScan API Only</option>
                  <option value="2">mDesking Only</option>
                  <option value="3">Primary Accounts</option>
                </b-form-select>
                <b-form-select class="mr-2" id="ddState" v-model="ddState" v-if="countryCode.value==='1'">
                  <option value="0">All (States)</option>
                  <option v-for="(option, name) in stateOptions" :value="name" v-bind:key="option">{{ name }} - {{ option }}</option>
                </b-form-select>
                <b-form-select class="mr-2" id="ddState" v-model="ddState" v-if="countryCode.value==='2'">
                  <option value="0">All (Provinces)</option>
                  <option v-for="(option, name) in provinceOptions" :value="name" v-bind:key="option">{{ name }} - {{ option }}</option>
                </b-form-select>
                <b-dropdown id="dropdown-left" v-model="countryCode" no-caret variant="outline-secondary"  v-bind:key="countryCode.value" style="height:35px; background-color: #ffffff !important;" class="mr-2 d-flex justify-content-between flagButton">
                  <template v-slot:button-content>
                    <div class="d-flex justify-content-between" style="width: 180px !important;">
                      <div v-if="countryCode.value === '0'" style="color: #000000 !important;">
                        All Countries
                      </div>
                      <div v-if="countryCode.value==='1'" style="color: #000000 !important;">
                        <img src="../assets/icons8-usa-96.png" class="flagImage" /> USA
                      </div>
                      <div v-if="countryCode.value==='2'" style="color: #000000 !important;">
                        <img src="../assets/icons8-canada-96.png" class="flagImage"/> CANADA
                      </div>
                      <div style="width:15px;float:right;">
                        <i class="fa fa-caret-down"></i>
                      </div>
                    </div>
                  </template>
                  <b-dropdown-item
                    :disabled="countryCodeOptions.disabled"
                    @click="selectCountryCode(option)"
                    v-for="option in countryCodeOptions" v-bind:key="option.value" style="min-width: 200px !important;">
                    <div>
                      <img v-if="option.src !== undefined" :src="option.src" class="flagImage">
                      {{option.text}}
                    </div>
                  </b-dropdown-item>
                </b-dropdown>
                <b-btn class="btn btn-success mr-2" @click="submitSearch">Search</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1 mt-2">

          <b-row>
            <b-col></b-col>
            <b-col md="6" style="text-align:left;">
              <div v-if="items.length > 0">
                <DxDropDownBox :value.sync="treeBoxValue"
                               :show-clear-button="true"
                               :data-source="treeDataSource"
                               value-expr="ID"
                               display-expr="NAME"
                               placeholder="Select a Features..."
                               @value-changed="syncTreeViewSelection($event)">
                  <template #content>
                    <DxTreeView :ref="treeViewName"
                                :data-source="treeDataSource"
                                :select-by-click="true"
                                :select-nodes-recursive="false"
                                key-expr="ID"
                                parent-id-expr="ID"
                                selection-mode="multiple"
                                show-check-boxes-mode="normal"
                                display-expr="NAME"
                                @content-ready="syncTreeViewSelection($event)"
                                @item-selection-changed="treeView_itemSelectionChanged($event)"
                                height="300"/>
                  </template>
                </DxDropDownBox>
                <!--<button style="width:40px;" @click="searchByFeature">...</button>-->
              </div>

            </b-col>
          </b-row>

        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table id="tblDealers" :items="filtered" hover striped bordered small :fields="fields" :current-page="currentPage" :per-page="perPage"
               :sort-compare="onSortChanged" show-empty @row-clicked="rowClickHandler" :empty-text="emptytext">
        <template slot="COUNTRY" slot-scope="row">
          <div v-if="row.value===1" class="d-flex justify-content-between">
            <DIV>USA</DIV><DIV style="float:right;"><img src="../assets/icons8-usa-96.png" class="flagImage" /></DIV>
          </div>
          <div v-if="row.value===2" class="d-flex justify-content-between">
            <DIV>CANADA</DIV><DIV style="float:right;"><img src="../assets/icons8-canada-96.png" class="flagImage" /></DIV>
          </div>
        </template>
        <template slot="CREATED_TS" slot-scope="row">
          {{row.value | formatDate}}
        </template>
        <template slot="EXPIRATION_DATE" slot-scope="row">
          {{row.value | formatDateAsIs}}
        </template>
        <!--<template slot="RECURRENT_PAYER" slot-scope="row"><input @click.stop type="checkbox" disabled v-model="row.value"></template>-->
        <!--<template slot="Type" slot-scope="row">
          <span v-if="row.value">mScan API</span>
          <span v-else>mDesking</span>
        </template>-->
        <template slot="IS_DISABLED" slot-scope="row">
          <input @click.stop type="checkbox" disabled v-model="row.value">
        </template>
        <template slot="FEATURES" slot-scope="row">
          <div style="width:200px">
            <ul>
              <li :key="item.Name" v-for="item in GetFeaturesFromString(row.value)">{{item.Name}}</li>
            </ul>
          </div>
        </template>
      </b-table>

      <!-- NAV -->
      <nav>
        <b-pagination :total-rows="totalCount" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
      </nav>

    </b-card>

  </base-page-component>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import moment from 'moment'
import { basePageMixin } from '@/mixins/basePageMixin'
import { DxDropDownBox, DxTreeView } from 'devextreme-vue'
import CustomStore from 'devextreme/data/custom_store'
import usImage from '../assets/icons8-usa-96.png'
import caImage from '../assets/icons8-canada-96.png'

export default {
  components: {
    loading,
    DxDropDownBox,
    DxTreeView
  },
  mixins: [basePageMixin],
  data () {
    return {
      treeDataSource: null,
      treeBoxValue: null,
      treeViewName: 'tree-view',
      ddAccountStatus: 0,
      ddAccountType: 0,
      ddState: 0,
      totalCount: 0,
      tbxFilter: '',
      items: [],
      filtered: [],
      fields: [
        { key: 'ACCOUNT_NUMBER', label: 'Account #', sortable: true },
        { key: 'PARTNER_NAME', label: 'Partner Name', sortable: true },
        { key: 'NAME', label: 'Name', sortable: true },
        { key: 'REGION', label: 'State/Province', sortable: true },
        { key: 'COUNTRY', label: 'Country', sortable: true },
        { key: 'MAXIMUM_USERS', label: 'Max Users', sortable: true },
        // { key: 'MAX_SIMULTANEOUS_USERS', label: 'Sim. Users', sortable: true },
        { key: 'CREATED_TS', label: 'Created', sortable: true },
        { key: 'EXPIRATION_DATE', label: 'Cutoff', sortable: true },
        // { key: 'RECURRENT_PAYER', label: 'Recurrent', sortable: true },
        { key: 'IS_DISABLED', label: 'Disabled', sortable: true },
        { key: 'ENTERPRISE_NAME', label: 'Associated Enterprise', sortable: true }
        //, { key: 'FEATURES', label: 'Features', sortable: false }
      ],
      currentPage: 1,
      perPage: 15,
      SelFeatures: true,
      emptytext: 'Please search for accounts',
      stateOptions: {
        'AL': 'Alabama',
        'AK': 'Alaska',
        'AS': 'American Samoa',
        'AZ': 'Arizona',
        'AR': 'Arkansas',
        'CA': 'California',
        'CO': 'Colorado',
        'CT': 'Connecticut',
        'DE': 'Delaware',
        'DC': 'District Of Columbia',
        'FM': 'Federated States Of Micronesia',
        'FL': 'Florida',
        'GA': 'Georgia',
        'GU': 'Guam',
        'HI': 'Hawaii',
        'ID': 'Idaho',
        'IL': 'Illinois',
        'IN': 'Indiana',
        'IA': 'Iowa',
        'KS': 'Kansas',
        'KY': 'Kentucky',
        'LA': 'Louisiana',
        'ME': 'Maine',
        'MH': 'Marshall Islands',
        'MD': 'Maryland',
        'MA': 'Massachusetts',
        'MI': 'Michigan',
        'MN': 'Minnesota',
        'MS': 'Mississippi',
        'MO': 'Missouri',
        'MT': 'Montana',
        'NE': 'Nebraska',
        'NV': 'Nevada',
        'NH': 'New Hampshire',
        'NJ': 'New Jersey',
        'NM': 'New Mexico',
        'NY': 'New York',
        'NC': 'North Carolina',
        'ND': 'North Dakota',
        'MP': 'Northern Mariana Islands',
        'OH': 'Ohio',
        'OK': 'Oklahoma',
        'OR': 'Oregon',
        'PW': 'Palau',
        'PA': 'Pennsylvania',
        'PR': 'Puerto Rico',
        'RI': 'Rhode Island',
        'SC': 'South Carolina',
        'SD': 'South Dakota',
        'TN': 'Tennessee',
        'TX': 'Texas',
        'UT': 'Utah',
        'VT': 'Vermont',
        'VI': 'Virgin Islands',
        'VA': 'Virginia',
        'WA': 'Washington',
        'WV': 'West Virginia',
        'WI': 'Wisconsin',
        'WY': 'Wyoming'
      },
      onSortChanged (a, b, key) {
        if (['accountLastRun', 'EXPIRATION_DATE'].indexOf(key) !== -1) {
          var a1
          var b1
          switch (key) {
            // case 'FUTUREUNKNOW':
            //  console.log(`${JSON.stringify(new Date())} (typeof a) ${(typeof a[key])} [${JSON.stringify(a[key])}] (typeof a) ${(typeof a[key])} [${JSON.stringify(a[key])}]`);
            //  break;
            case 'CREATED_TS':
            case 'accountLastRun':
              a1 = moment(a[key])
              b1 = moment(b[key])

              if (a1.isValid() && b1.isValid()) {
                if (a1.isSame(b1)) {
                  return 0
                }
                if (a1.isAfter(b1)) {
                  return 1
                }
                return -1
              } else {
                if (a1.isValid()) {
                  return 1
                }
                if (b1.isValid()) {
                  return -1
                }
              }
              return 0
          }
        } else {
          if (typeof a[key] === 'number' && typeof b[key] === 'number') {
            // If both compared fields are native numbers
            return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
          } else if (typeof a[key] === 'boolean' && typeof b[key] === 'boolean') {
            a1 = ((a[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            b1 = ((b[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            return a1 < b1 ? 1 : (a1 > b1 ? -1 : 0)
          } else {
            a1 = (a[key] + '')
            b1 = (b[key] + '')
            return (a1).localeCompare(b1)
          }
        }
      },
      countryCodeOptions: [
        {
          value: '0',
          text: 'All Countries',
          src: undefined
        },
        {
          value: '1',
          text: 'USA',
          src: usImage
        },
        {
          value: '2',
          text: 'CANADA',
          src: caImage
        }
      ],
      provinceOptions: {
        'AB': 'Alberta',
        'BC': 'British Columbia',
        'MB': 'Manitoba',
        'NB': 'New Brunswick',
        'NL': 'Newfoundland and Labrador',
        'NT': 'Northwest Territories',
        'NS': 'Nova Scotia',
        'NU': 'Nunavut',
        'ON': 'Ontario',
        'PE': 'Prince Edward Island',
        'QC': 'Quebec',
        'SK': 'Saskatchewan',
        'YT': 'Yukon'
      },
      provinceOptionsArray: [
        {'Code': 'AB', 'Name': 'Alberta'},
        {'Code': 'BC', 'Name': 'British Columbia'},
        {'Code': 'MB', 'Name': 'Manitoba'},
        {'Code': 'NB', 'Name': 'New Brunswick'},
        {'Code': 'NL', 'Name': 'Newfoundland and Labrador'},
        {'Code': 'NT', 'Name': 'Northwest Territories'},
        {'Code': 'NS', 'Name': 'Nova Scotia'},
        {'Code': 'NU', 'Name': 'Nunavut'},
        {'Code': 'ON', 'Name': 'Ontario'},
        {'Code': 'PE', 'Name': 'Prince Edward Island'},
        {'Code': 'QC', 'Name': 'Quebec'},
        {'Code': 'SK', 'Name': 'Saskatchewan'},
        {'Code': 'YT', 'Name': 'Yukon'}
      ],
      countryCode: undefined
    }
  },
  created () {
    let self = this
    self.countryCode = self.countryCodeOptions[1]
    this.treeDataSource = this.makeAsyncDataSource()
    this.treeBoxValue = []
    setTimeout(function () {
      self.toggleloader(false)
    }, 500)
  },
  methods: {
    makeAsyncDataSource () {
      return new CustomStore({
        loadMode: 'raw',
        key: 'ID',
        load: function () {
          return fetch(
            `/api/Subscriptions/GetFeatures`
          ).then(response => response.json())
        }
      })
    },
    syncTreeViewSelection (e) {
      let treeView =
          (e.component.selectItem && e.component) ||
          (this.$refs[this.treeViewName] &&
            this.$refs[this.treeViewName].instance)
      if (treeView) {
        if (e.value === null) {
          treeView.unselectAll()
          this.filtered = this.items
          this.totalCount = this.filtered.length
        } else {
          let values = e.value || this.treeBoxValue
          values &&
              values.forEach(function (value) {
                treeView.selectItem(value)
              })
          this.WhenListChange(e)
        }
      }
    },
    treeView_itemSelectionChanged (e) {
      this.treeBoxValue = e.component.getSelectedNodesKeys()
    },
    WhenListChange (e) {
      if (this.treeBoxValue.length === 0) {
        this.filtered = this.items
        this.totalCount = this.filtered.length
      } else {
        this.searchByFeature()
        this.totalCount = this.filtered.length
      }
    },
    rowClickHandler (record, index) {
      let self = this
      self.$router.push('/account/' + record.ACCOUNT_NUMBER)
    },
    showCreate () {
      let self = this
      self.$router.push('/accounts/create')
    },
    getRowCount () {
      let self = this

      let itemsCount = self.filtered.length// self.items.length
      let totalpages = Math.ceil(itemsCount / self.perPage)
      let totalfullpages = Math.floor(itemsCount / self.perPage)

      if (itemsCount === 0 || itemsCount < self.perPage) {
        return itemsCount
      } else if (self.currentPage < totalpages) {
        return self.perPage
      }
      return itemsCount - totalfullpages * self.perPage
    },
    searchByFeature () {
      let self = this
      self.filtered = self.items.filter(x => self.applyFilter(x.FEATURES, self.treeBoxValue))
      self.totalCount = self.filtered.length
    },
    applyFilter (featuresInAccount, features) {
      let self = this
      if (featuresInAccount == null) return false
      var arrayFeatureInAccount = self.GetFeaturesFromString(featuresInAccount)
      var count = features.length
      var res = arrayFeatureInAccount.filter(x => self.isItemInList(x, features)).length === count
      return res
    },
    isItemInList (item, list) {
      var res = list.filter(x => x === parseInt(item.Id)).length > 0
      return res
    },

    submitSearch () {
      let self = this
      self.toggleloader(true)
      let params = '?q=' + self.tbxFilter + '&as=' + self.ddAccountStatus + '&at=' + self.ddAccountType + '&st=' + self.ddState + '&co=' + self.countryCode.value + '&feature=' + self.treeBoxValue
      axios.get('/api/accounts/loadlist' + params)
        .then(response => {
          self.filtered = self.items = response.data
          self.totalCount = self.items.length
          self.emptytext = 'There are no accounts to show'
        })
        .catch(error => {
          self.handleError(error)
        }).then(r => {
          self.toggleloader(false)
        })
    },
    GetFeaturesFromString (strFeatures) {
      var features = strFeatures.split(',')
      features = features.filter(x => x.length > 0)
      var f = []
      features.forEach(x => f.push({ Id: x.split(':')[0], Name: x.split(':')[1] }))
      return f
    },
    selectCountryCode (option) {
      if (option === 'All') { this.countryCode = undefined } else { this.countryCode = option }
    },
    IsCanada (region) {
      const self = this
      if (self.countryCode.value === '2') {
        return true
      }
      return false
      // return self.provinceOptionsArray.filter(x => x.Code === region).length > 0
    }
  },
  filters: {
    formatDate: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY')
      }
      return ''
    },
    formatDateAsIs: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.format('MM/DD/YYYY')
      }
      return ''
    }
  }
}
</script>
<style scoped>
  .FeatureColumn {
    width: 100px;
  }
  .flagImage {
    width: 25px;
    height: 25px;
  }
  .flagButton {
    background-color: #ffffff;
  }
  .btn {
    min-width: 200px !important;
  }
/*
  .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle, .show > .btn-secondary.dropdown-toggle-no-caret {
    color: #000000 !important;
    background-color: #FFFFFF !important;
    border-color: #7e99a7;
    min-width: 200px !important;
  }

  .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle, .show > .btn-outline-secondary.dropdown-toggle-no-caret {
    color: #000000 !important;
    background-color:  #FFFFFF !important;
    min-width: 200px !important;
  }
*/
</style>



// WEBPACK FOOTER //
// src/views/Accounts.vue